import React from "react";
import DarkModeSwitch from "./DarkModeSwitch";

function Header({ mode, toggleMode }) {
  return (
    <header className="mt-3 mb-2">
      <div className="container px-4 px-md-0">
        <div className="row ">
          <div className="justify-content-end mb-4 mb-lg-0">
            <DarkModeSwitch mode={mode} toggleMode={toggleMode} />
          </div>
          <div className="col-12 mb-4">
            <h1 className="text-center ">
              <span className="visually-hidden">GameStirke</span>
              <a href="/"><img src="./images/logo.svg" width="588" height="57" alt="GameStirke" className="logo img-fluid"/></a>
            </h1>
            <h2 className="text-center">
              Your destination for video game news.
            </h2>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
